const { default: ApiService } = require("./api.service");

const PasswordService = {
    // Richiede l'invio del link di recupero password
    sendResetLink: (email) => 
        ApiService.fetch('password/email', {
            method: 'POST',
            body: JSON.stringify({ email })
        }),
    
    // Verifica la validità di un token
    validateToken: (email, token) => 
        ApiService.fetch('password/validate-token', {
            method: 'POST',
            body: JSON.stringify({ email, token })
        }),
    
    // Reimposta la password
    resetPassword: (email, token, password, password_confirmation) => 
        ApiService.fetch('password/reset', {
            method: 'POST',
            body: JSON.stringify({
                email,
                token,
                password,
                password_confirmation
            })
        })
};

export default PasswordService;